import { useState } from "react";

const MODALES_INICIALES = {
  nuevoPedido: false,
  asignar: false,
  anularPedido: false,
  editarPedido: false,
  reclamarPedido: false,
  reabrir: false,
  facturar: false,
  linkPago: false,
  verLink: false,
};

// Estado centralizado de "qué modal de acción está abierto y sobre qué pedido".
// Único punto de verdad para que tabla y tarjetas abran exactamente los
// mismos modales reutilizados del módulo original.
const useAccionesPedido = (onCerrarModal) => {
  const [modales, setModales] = useState(MODALES_INICIALES);
  const [pedidoActivo, setPedidoActivo] = useState(null);

  const abrirModal = (key, pedido = null) => {
    if (pedido) setPedidoActivo(pedido);
    setModales((prev) => ({ ...prev, [key]: true }));
  };

  const cerrarModal = (key) => {
    setModales((prev) => ({ ...prev, [key]: false }));
    onCerrarModal?.();
  };

  const hayModalAbierto = Object.values(modales).some(Boolean);

  return { modales, pedidoActivo, abrirModal, cerrarModal, hayModalAbierto };
};

export default useAccionesPedido;
